var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"fit-content","font-size":"12px","background-color":"white"}},[_c('h2',{staticStyle:{"margin-top":"5px"}},[_vm._v("Saved Charts Admin")])])
}]

export { render, staticRenderFns }